import { Pipe, PipeTransform, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { WarehouseRestockTypeProviderService } from '../providers/warehouse-restock-type-provider.service';
import { WarehouseRestockType } from '../enums/warehouse-restock-type';

@Pipe({
  name: 'warehouseRestockType',
  standalone: true,
})
export class WarehouseRestockTypePipe implements PipeTransform {
  private readonly provider = inject(WarehouseRestockTypeProviderService);

  public transform(type: WarehouseRestockType): Observable<string> {
    return this.provider.label(type);
  }
}
